/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LeverageSupplyOptions,
  LeverageSupplyStatus201,
  LeverageSupplyStatus400,
  LeverageSupplyStatus401,
  LeverageSupplyStatus500,
} from '../types/LeverageSupply'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { leverageSupply } from '../clients/leverageSupply'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const leverageSupplyMutationKey = () => [{ url: '/v1/leverage/supply' }] as const

export function leverageSupplyMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = leverageSupplyMutationKey()
  return mutationOptions<
    LeverageSupplyStatus201,
    ResponseErrorConfig<
      LeverageSupplyStatus400 | LeverageSupplyStatus401 | LeverageSupplyStatus500
    >,
    LeverageSupplyOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return leverageSupply({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Supply leverage for a specific asset
 * {@link /v1/leverage/supply}
 */
export function useLeverageSupply<TContext>(
  options: {
    mutation?: UseMutationOptions<
      LeverageSupplyStatus201,
      ResponseErrorConfig<
        LeverageSupplyStatus400 | LeverageSupplyStatus401 | LeverageSupplyStatus500
      >,
      LeverageSupplyOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? leverageSupplyMutationKey()

  const baseOptions = leverageSupplyMutationOptions(config) as UseMutationOptions<
    LeverageSupplyStatus201,
    ResponseErrorConfig<
      LeverageSupplyStatus400 | LeverageSupplyStatus401 | LeverageSupplyStatus500
    >,
    LeverageSupplyOptions,
    TContext
  >

  return useMutation<
    LeverageSupplyStatus201,
    ResponseErrorConfig<
      LeverageSupplyStatus400 | LeverageSupplyStatus401 | LeverageSupplyStatus500
    >,
    LeverageSupplyOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    LeverageSupplyStatus201,
    ResponseErrorConfig<
      LeverageSupplyStatus400 | LeverageSupplyStatus401 | LeverageSupplyStatus500
    >,
    LeverageSupplyOptions,
    TContext
  >
}
